/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-stakeholder': {
    width: 14,
    height: 13,
    viewBox: '0 0 14 13',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3 3.416a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm5.5 5.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM5.82 6.132a.5.5 0 0 1 .539-.2l2.269.6A.5.5 0 0 1 9 7.017v1.025a.5.5 0 0 1 .729.073l.863 1.136.855-1.135a.5.5 0 0 1 .517-.185l1.653.4a.5.5 0 0 1 .383.486v3.6a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-5.4a.5.5 0 0 1 .373-.483l2.279-.6a.5.5 0 0 1 .537.198l1.321 1.9 1.31-1.899zM9 11.916h4V9.21l-.952-.23-1.055 1.4a.5.5 0 0 1-.798 0l-.843-1.109A.5.5 0 0 1 9 9.416v2.5zM1 7.401v4.515h7V7.401l-1.557-.412-1.52 2.204a.5.5 0 0 1-.822.002L2.568 6.989 1 7.4z" _fill="#0D204A"/>'
  }
})
